import { ColorType, createChart } from "lightweight-charts";
import { useEffect, useRef } from "react";
import "./RulesCharts.scss";
import { useState } from "react";
import { useTheme } from "hooks/ThemeContext";

const RulesCharts = ({
  data,
  variant,
  maxDrawdownValue,
  dailyDrawdownValue,
  maxBalance,
  noDailyDrawdown,
  noStartBalance,
}) => {
  const { theme } = useTheme();

  const chartRef = useRef(null);
  const areaSeriesRef = useRef(null);
  const backgroundColor = "transparent";
  const lineColor = `${variant === "secondary" ? "#40AEEE" : "#ED21217d"}`;
  const textColor = theme === "dark" ? "black" : "white";
  const areaTopColor = `${
    variant === "secondary" ? "transparent" : "transparent"
  }`;
  const areaBottomColor = `${
    variant === "secondary" ? "transparent" : "transparent"
  }`;
  const chartContainerRef = useRef(null);

  useEffect(() => {
    const minDataValue = Math.min(...data.map((point) => point.value));
    const maxDataValue = Math.max(...data.map((point) => point.value));
    const minValue = Math.min(
      minDataValue,
      dailyDrawdownValue,
      maxDrawdownValue
    );
    const maxValue = Math.max(maxBalance, maxDataValue) + 1000;

    console.log(minValue, maxValue);

    chartRef.current = createChart(chartContainerRef.current, {
      height: 250,
      layout: {
        background: { type: ColorType.Solid, color: backgroundColor },
        textColor: textColor,
        fontFamily: "N-Bold",
      },
      grid: {
        vertLines: { visible: false },
        horzLines: { visible: false },
      },
      timeScale: {
        visible: false,
        autoScale: false,
      },
      rightPriceScale: {
        visible: false,
        autoScale: false,
      },

      leftPriceScale: { visible: false, autoScale: false },
      handleScroll: false,
      handleScale: false,
    });

    areaSeriesRef.current = chartRef.current.addAreaSeries({
      lineColor,
      lineWidth: 1.5,
      topColor: areaTopColor,
      bottomColor: areaBottomColor,
      lastValueVisible: true,
      priceLineVisible: false,
      paneInteract: false,
      priceScaleId: "left",

      priceFormat: {
        type: "custom",
        formatter: function (price) {
          return `${price.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}`;
        },
      },
    });

    areaSeriesRef.current.setData(data);

    const MaxEquityPriceLine = {
      price: Number(maxBalance) || 0,
      color: `#40AEEE`,
      axisLabelTextColor: theme === "dark" ? "#000000" : "white",
      axisLabelColor: "#40AEEE",
      lineWidth: 1.5,
      lineStyle: 3,
      axisLabelVisible: true,
      title: noStartBalance
        ? "Max Daily Equity: " +
          maxBalance?.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })
        : "Starting Balance: " +
          maxBalance?.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          }),
    };

    const DDPriceLine = {
      price: Number(dailyDrawdownValue) || 0,
      color: `#9A9A9A`,
      axisLabelTextColor: theme === "dark" ? "#000000" : "white",
      axisLabelColor: "#9A9A9A",
      lineWidth: 1.5,
      lineStyle: 3,
      axisLabelVisible: true,
      title:
        "Max Daily Loss : " +
        dailyDrawdownValue?.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        }),
    };

    const MDPriceLine = {
      price: Number(maxDrawdownValue) || 0,
      color: `#56C72B`,
      axisLabelTextColor: theme === "dark" ? "#000000" : "white",
      axisLabelColor: "#56C72B",
      lineWidth: 1.5,
      lineStyle: 3,
      axisLabelVisible: true,
      title:
        "Max Loss: " +
        maxDrawdownValue?.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        }),
    };

    areaSeriesRef.current.createPriceLine(MaxEquityPriceLine);
    {
      !noDailyDrawdown && areaSeriesRef.current.createPriceLine(DDPriceLine);
    }
    areaSeriesRef.current.createPriceLine(MDPriceLine);

    chartRef.current.applyOptions({
      watermark: {
        color: "rgba(0, 0, 0, 0)",
        visible: false,
        text: "",
        fontSize: 24,
        horzAlign: "left",
        vertAlign: "top",
      },
      priceLineVisible: false,
      lastValueVisible: false,

      priceScaleMode: 1,
    });

    chartRef.current.timeScale().fitContent();

    areaSeriesRef.current.applyOptions({
      autoscaleInfoProvider: () => {
        return {
          priceRange: {
            minValue: minValue - 500,
            maxValue: maxValue + 500,
          },
        };
      },
    });

    return () => {
      chartRef.current.remove();
    };
  }, [data, maxBalance, maxDrawdownValue, dailyDrawdownValue]);

  useEffect(() => {
    if (chartRef.current) {
      areaSeriesRef.current.setData(data);
    }
  }, [data, maxBalance, maxDrawdownValue, dailyDrawdownValue]);

  return (
    <div className="chart_cont cursor-pointer w-full !font-G_Bold">
      <div ref={chartContainerRef} className="w-full"></div>
    </div>
  );
};

export default RulesCharts;
